<div class="flex h-14 justify-start p-3 md:hidden">
  <app-button
    theme="transparent"
    styleClass="w-8"
    [icon]="true"
    (click)="_back()">
    <ic-arrow-left-outline class="block h-5 w-5" />
  </app-button>
</div>
<div class="px-6 py-4">
  <form
    class="mx-auto max-w-95 space-y-6 p-6 px-6 text-center md:py-40"
    [formGroup]="form">
    @switch (step) {
      @default {
        <div class="space-y-2">
          <p class="text-text-default text-xl font-bold">Atur Ulang Pin Akses</p>
          <p class="text-text-default text-sm">Buat nomor pin baru yang kuat untuk akunmu.</p>
        </div>
        <div class="flex items-center justify-center gap-2">
          <p-inputOtp
            formControlName="pin"
            [length]="pinLength"
            [integerOnly]="true"
            (ngModelChange)="formError.pin.msg = ''">
            <ng-template
              pTemplate="input"
              let-token
              let-events="events"
              let-index="index">
              <input
                pInputText
                type="text"
                autocomplete="one-time-code"
                class="text-text-brand border-line-default focus:border-line-brand focus:outline-line-brand h-11 w-11 rounded-xl border bg-transparent text-center text-2xl font-bold transition"
                [pAutoFocus]="index === 0"
                [ngClass]="{ 'text-text-error border-line-error': formError.pin.msg }"
                (input)="events.input($event)"
                (keydown)="events.keydown($event)"
                (paste)="_onPaste($event, 'pin')"
                [type]="pinType"
                [attr.value]="token"
                [maxLength]="1" />
            </ng-template>
          </p-inputOtp>
          <app-button
            theme="transparent"
            styleClass="!h-10 rounded-lg"
            [icon]="true"
            (click)="_togglePinType()">
            @if (pinType === "password") {
              <ic-eye-on class="block h-5 w-5" />
            } @else {
              <ic-eye-off class="block h-5 w-5" />
            }
          </app-button>
        </div>
        <app-button
          class="mx-auto block w-80"
          styleClass="h-10"
          [disabled]="form.value.pin?.length !== pinLength"
          (click)="_toStepConfirm()">
          Konfirmasi Pin
        </app-button>
      }
      @case ("confirm") {
        <div class="space-y-2">
          <p class="text-text-default text-xl font-bold">Konfirmasi Ulang Pin Akses</p>
          <p class="text-text-default text-sm">Masukkan Kembali Nomor Pin</p>
        </div>
        <div class="flex items-center justify-center gap-2">
          <p-inputOtp
            formControlName="pin_confirmation"
            [length]="pinLength"
            [integerOnly]="true"
            (ngModelChange)="formError.pin_confirmation.msg = ''">
            <ng-template
              pTemplate="input"
              let-token
              let-events="events"
              let-index="index">
              <input
                pInputText
                type="text"
                autocomplete="one-time-code"
                class="text-text-brand border-line-default focus:border-line-brand focus:outline-line-brand h-11 w-11 rounded-xl border bg-transparent text-center text-2xl font-bold transition"
                inputmode="numeric"
                pattern="[0-9]*"
                [pAutoFocus]="index === 0"
                [ngClass]="{ 'text-text-error border-line-error': formError.pin_confirmation.msg }"
                (input)="events.input($event)"
                (keydown)="events.keydown($event)"
                (paste)="_onPaste($event, 'pin_confirmation')"
                [type]="pinType"
                [attr.value]="token"
                [maxLength]="1" />
            </ng-template>
          </p-inputOtp>
          <app-button
            theme="transparent"
            styleClass="!h-10 rounded-lg"
            [icon]="true"
            (click)="_togglePinType()">
            @if (pinType === "password") {
              <ic-eye-on class="block h-5 w-5" />
            } @else {
              <ic-eye-off class="block h-5 w-5" />
            }
          </app-button>
        </div>
        @if (formError.pin_confirmation.msg) {
          <div class="flex items-center justify-center gap-1">
            <ic-warning-triangle-outline class="text-icon-error block h-3 w-3" />
            <p class="text-text-error text-xs leading-0 font-medium">
              {{ formError.pin_confirmation.msg }}
            </p>
          </div>
        }
        <div class="bg-bg-tint-warning flex gap-2.5 rounded-lg mask-luminance p-3 text-left">
          <ic-warning-circle-outline class="text-icon-subtle/80 block h-4 w-4 shrink-0" />
          <p class="text-text-subtler/80 text-xs">
            Dengan memperbarui Pin Akses maka semua akun yang terhubung maka akan dipaksa logout
            atau keluar dari sistem
          </p>
        </div>
        <app-button
          class="mx-auto block w-80"
          styleClass="h-10"
          [disabled]="formSubmitting()"
          (click)="_onSubmit()">
          Simpan
        </app-button>
      }
    }
  </form>
</div>
